import { request } from "../_helpers/Auth";

const namespace = "/api/planning-hour-limit-rules";

export const getPlanningHourLimitRules = () => {
    return request({
        url: namespace,
        method: "get",
    });
};

export const createPlanningHourLimitRule = (payload) => {
    return request({
        url: namespace,
        method: "post",
        data: payload,
    });
};

export const updatePlanningHourLimitRule = (id, payload) => {
    return request({
        url: `${namespace}/${id}`,
        method: "put",
        data: payload,
    });
};

export const destroyPlanningHourLimitRule = (id) => {
    return request({
        url: `${namespace}/${id}`,
        method: "delete",
    });
};

export const checkPlanningHourLimits = (payload) => {
    return request({
        url: "/api/planning/hour-limits/check",
        method: "post",
        data: payload,
    });
};

export const checkPlanningHourLimitsRange = (payload) => {
    return request({
        url: "/api/planning/hour-limits/check-range",
        method: "post",
        data: payload,
    });
};

export const RULE_PRESETS = [
    {
        name: "Semaine contractuelle 35h",
        period_type: "week",
        period_weeks: null,
        aggregation: "total",
        limit_unit: "hours",
        max_hours: 35,
        enforcement: "block",
        hour_type_filter: "work",
    },
    {
        name: "Semaine contractuelle 36h",
        period_type: "week",
        period_weeks: null,
        aggregation: "total",
        limit_unit: "hours",
        max_hours: 36,
        enforcement: "block",
        hour_type_filter: "work",
    },
    {
        name: "Moyenne 12 semaines max 44h",
        period_type: "rolling_weeks",
        period_weeks: 12,
        aggregation: "average",
        limit_unit: "hours",
        max_hours: 44,
        enforcement: "block",
        hour_type_filter: "work",
    },
    {
        name: "Semaine max 48h",
        period_type: "week",
        period_weeks: null,
        aggregation: "total",
        limit_unit: "hours",
        max_hours: 48,
        enforcement: "block",
        hour_type_filter: "work",
    },
    {
        name: "Semaine max 2 jours RTT",
        period_type: "week",
        period_weeks: null,
        aggregation: "total",
        limit_unit: "days",
        max_hours: 2,
        enforcement: "block",
        hour_type_filter: "absence",
    },
];
